/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import axios from 'axios';
import { connect } from "react-redux";
import {addUser} from 'actions/index';


function mapDispatchToProps(dispatch) {
  return {
    addUser: user => dispatch(addUser(user))
  };
}

class UserHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      full_name: '',
     naviagate:false
    };
    this.getUserData = this.getUserData.bind(this);
  }

  componentDidMount(){
    this.setState({full_name:localStorage.getItem('full_name')});
    this.getUserData();
  }

  getUserData() {
    let token = localStorage.getItem('access_token');
    axios.get('https://markerportalbackend.thinkdigitalacademy.org/api/user',{headers: {
        'Authorization': `Bearer ${token}` 
      }}).then(res=>{
          // //console.log('user user header',res.data);
         this.props.addUser(res.data);   
        //  //console.log('props',this.props);    
      }).catch(error =>{
          // //console.log('error',error);
      });    
  }


  render() {
    return (
      <>
        <div
          className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
          style={{
            minHeight: "200px",
            backgroundImage:
              "url(" + require("assets/img/brand/banner01.png") + ")",
            backgroundSize: "cover",
            backgroundPosition: "center top"
          }}
        >
          
          <span className="mask bg-gradient-default opacity-8" />
        </div>
      </>
    );
  }
}
export default connect(
  null,mapDispatchToProps
)(UserHeader);
